export const serviceDetailKeys = {
  imageUrl: "imageUrl",
  title: "title",
  infoList: "infoList",
}